(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oolo-avis-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oolo-reviews-slider')) {
    class OoloReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index() - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index() + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index() - 1); }
        });

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.build();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      step() {
        if (this.slides.length < 2) return this.track.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      visible() {
        const s = this.step();
        return s > 0 ? Math.max(1, Math.round((this.track.clientWidth + 1) / s)) : 1;
      }

      pages() {
        return Math.max(1, this.slides.length - this.visible() + 1);
      }

      index() {
        const s = this.step();
        return s > 0 ? Math.round(this.track.scrollLeft / s) : 0;
      }

      go(i) {
        const pages = this.pages();
        const target = Math.min(Math.max(i, 0), pages - 1);
        this.track.scrollTo({ left: target * this.step(), behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }

      build() {
        const pages = this.pages();
        this.toggleAttribute('data-static', pages <= 1);
        if (this.dotsWrap) {
          this.dotsWrap.innerHTML = '';
          if (pages > 1) {
            for (let i = 0; i < pages; i++) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'oolo-reviews__dot';
              dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
              dot.addEventListener('click', () => this.go(i));
              this.dotsWrap.appendChild(dot);
            }
          }
        }
        this.update();
      }

      update() {
        const i = this.index();
        const pages = this.pages();
        if (this.prevBtn) this.prevBtn.disabled = i <= 0;
        if (this.nextBtn) this.nextBtn.disabled = i >= pages - 1;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, n) => {
            dot.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }
      }

      onScroll() {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.update());
      }

      onResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.build(), 150);
      }

      onBlockSelect(event) {
        const slide = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
        if (!slide) return;
        this.go(Math.min(this.slides.indexOf(slide), this.pages() - 1));
      }
    }

    customElements.define('oolo-reviews-slider', OoloReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
